import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
} from "reactstrap";
import RequestEngine from "../../core/RequestEngine";
import CoreEngine from "../../core/CoreEngine";
import ButtonLoader from "../../components/ButtonLoader/ButtonLoader";
import SelectRow from "../../components/Select/SelectRow";
import FormRow from "../../components/Row/FormRow";
import { AvForm } from "availity-reactstrap-validation";
import strings from "../../core/translate";

export default class NotificationAddUpdate extends CoreEngine {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      id: "",
      name: "",
      status: "",
      statuslist: [
        { value: "processed", label: "processed" },
        { value: "pending", label: "Pending" },
        { value: "fulfilled", label: "fulfilled" },
        { value: "visualized", label: "visualized" },
        { value: "failed", label: "failed" },
        { value: "processing_failed", label: "processing_failed" },
      ],
      method: "",
      methodlist: [
        { value: "email", label: "email" },
        { value: "sms", label: "sms" },
        { value: "other", label: "other" },
      ],
      loading: false,
    };

    this.pathname = "Notifications";
    this.engine = new RequestEngine();
  }

  componentDidMount() {
    const edit = this.props.location.data;
    if (edit) {
      this.setState({
        ...edit,
      });
    }
  }

  handleValidSubmit = async () => {
    this.setState({ loading: true });

    const { id, ...data } = this.state;
    let response;
    try {
      if (id) {
        response = await this.engine.updateItem(this.pathname, id, data);
      } else {
        response = await this.engine.saveItem(this.pathname, data);
      }

      if (response && (response.status === 201 || response.status === 200)) {
        this.props.history.push("/admin/" + this.pathname);
      }
    } catch (err) {
      // This block will handle exceptions, including the BadRequestException
      if (err.response && err.response.status === 400) {
        // Handle specific error with detailed message
        alert("Error: " + err.response.data.message.join(", "));
      } else {
        // Handle general errors
        alert("An unexpected error occurred: " + err.message);
      }
    }

    this.setState({ loading: false });
  };

  render() {
    const {
      loading,
      isLoading,
      data,
      recipient,
      template,
      status,
      statuslist,
      id,
      method,
      methodlist,
    } = this.state;

    if (isLoading) {
      return this.renderProgress();
    }

    return (
      <div className="content english">
        <Row>
          <Col md="12">
            <AvForm
              onValidSubmit={this.handleValidSubmit}
              className="form-horizontal"
              id="TypeValidation"
            >
              <Card>
                <CardHeader>
                  <CardTitle tag="h4">{strings.information}</CardTitle>
                </CardHeader>
                <CardBody>
                  <FormRow
                    label={strings.data}
                    name="data"
                    data={data}
                    changeInput={this.changeInput}
                  />
                  {!id && (
                    <FormRow
                      label={strings.recipient}
                      name="recipient"
                      data={recipient}
                      changeInput={this.changeInput}
                    />
                  )}
                  <FormRow
                    label={strings.template}
                    name="template"
                    data={template}
                    changeInput={this.changeInput}
                    required={false}
                  />
                  {id && (
                    <SelectRow
                      label={strings.status}
                      name="status"
                      defaultValue={status}
                      data={statuslist}
                      changeInput={this.changeInput.bind(this)}
                    />
                  )}
                  {id && (
                    <SelectRow
                      label={strings.method}
                      name="method"
                      defaultValue={method}
                      data={methodlist}
                      changeInput={this.changeInput.bind(this)}
                    />
                  )}
                </CardBody>
                <CardFooter className="text-center">
                  <ButtonLoader color="primary" loading={loading}>
                    {strings.save}
                  </ButtonLoader>
                </CardFooter>
              </Card>
            </AvForm>
          </Col>
        </Row>
      </div>
    );
  }
}
